
























import {
    Component, Prop, Vue, ComparisonManager, ComponentStyle,
    ComponentStyleDefinition, VueComponent, InjectComponent
} from "@zoovu/runner-browser-api";

@Component({})
export default class ComparisonView extends Vue {

    @Prop()
    comparisonManager: ComparisonManager;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @InjectComponent("ComparisonTableView")
    comparisonTableView: VueComponent;

    bodyOverflow: string = 'initial';
    isInlineOverflow: boolean = false;

    setBodyOverflowHidden(): void {
        const style = getComputedStyle(document.querySelector('body'));
        const overflowStyle = style.overflow;
        if (overflowStyle) {
            this.bodyOverflow = overflowStyle;
        }
        this.isInlineOverflow = !!document.querySelector('body').style.overflow;

        document.querySelector('body').style.overflow = "hidden";
    }

    resetBodyOverflow(): void {
        if (this.isInlineOverflow) {
            document.querySelector('body').style.overflow = this.bodyOverflow;
        } else {
            document.querySelector('body').style.removeProperty('overflow');
        }
    }

    onClose(): void {
        this.resetBodyOverflow();
        this.comparisonManager.deactivate();
    }

    destroy(): void {
        this.resetBodyOverflow();
    }

    mounted(): void {
        this.$root.$on("start-compare", () => {
            this.comparisonManager.activate();
            this.setBodyOverflowHidden();
        });
    }

}
